import { PermissionMessengerOption } from '../keys/permissionMessenger.interface';
import { PermissionOption } from '../models/permissionOption.interface';

export const PermissionMessenger: PermissionOption[] = [
  { code: 'PXXX', option: PermissionMessengerOption.MESSENGER_COMMON_LOGIN, permissions: ['messenger.common.login'] },
];
